import Navbar from "./Navbar";
import about4 from "../images/about4.jfif";
import about1 from "../images/about1.jpeg";
import about2 from "../images/about2.jpeg";
import about3 from "../images/about3.jpeg";
import overlay from "../images/overlay.png";
const AboutContent = () => {
  return (
    <div style={{ height: "calc(100vh)" }} className="about relative">
      <Navbar />
      <div className="overflow-hidden flex h-full relative lg:px-32 md:px-20 sm:px-16 px-10">
        <div className="flex w-full items-center justify-start h-full ">
          <div className="w-full text-center flex itmes-center justify-center flex-col font-extrabold z-[1] ">
            <h1 className="lg:text-8xl md:text-7xl sm:text-6xl text-4xl text-white font leading-tight">
              ABOUT US
            </h1>
            <p className="text-gray-500 sm:text-xl text-lg">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
              molestiae fugit beatae.
            </p>
          </div>
        </div>
        <img
          src={overlay}
          className="w-[100vw] h-full absolute top-0 left-0 overflow-hidden"
          alt=""
        />
      </div>
    </div>
  );
};
export default AboutContent;
